import { useEffect, useState } from 'react';
import { useAuth, useModal, useToast } from 'contexts';
import { Rating } from 'react-simple-star-rating';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { SubmitHandler, useForm } from 'react-hook-form';
import { registerEvaluate, getEvaluate } from 'services';
import { toast } from 'react-toastify';

import './style.scss';

type Props = {
  contentId?: string;
  title?: string;
  type?: string;
  class?: string;
  onClose?: () => void;
};

type InputsForm = {
  [key: string]: any;
  comentario: string;
};

export function Evaluate({ contentId, title, type, onClose, ...rest }: Props) {
  const { closeModal } = useModal();
  const { user } = useAuth();
  const [rating, setRating] = useState(0);
  const [sending, setSending] = useState(false);
  const [hasCheckedEvaluation, setHasCheckedEvaluation] = useState(false);
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const [starRatingError, setStarRatingError] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm<InputsForm>();
  const { toastify } = useToast();

  const form_message = watch('comentario', '');

  const handleRating = (rate: number) => {
    setRating(rate);
    if (rate > 0) {
      setStarRatingError(null);
    }
  };

  const onSubmit: SubmitHandler<InputsForm> = async data => {
    if (rating === 0) {
      setStarRatingError('Por favor, selecione uma avaliação de estrelas.');
      return;
    }

    setSending(true);

    const obj = {
      userId: user?._id,
      rating: rating,
      contentId: contentId,
      title: title,
      type: type,
      comment: data.comentario,
      created: { $date: new Date().getTime() },
    };

    registerEvaluate(obj)
      .then(res => {
        if (res._id) {
          toast.success('Avaliação enviada com sucesso.');
        }
      })
      .finally(() => {
        setSending(false);
        closeModal();
        if (onClose) {
          onClose();
        }
      });
  };

  useEffect(() => {
    if (user && contentId && !hasCheckedEvaluation) {
      getEvaluate(user?._id, contentId).then(res => {
        if (res[0]) {
          toast.error('Você já avaliou este conteúdo.');
          closeModal();

          if (onClose) {
            onClose();
          }
        } else {
          setShouldShowModal(true);
        }
        setHasCheckedEvaluation(true);
      });
    }
  }, [closeModal, contentId, user, hasCheckedEvaluation, onClose]);

  if (!contentId || !shouldShowModal) return null;

  return (
    <section id="evaluate">
      <div>
        <p className="title">Avaliação de conteúdo</p>
        <div className="rating">
          <Rating
            onClick={handleRating}
            fillColorArray={['#f17a45', '#f19745', '#f1a545', '#f1b345', '#f1d045']}
            emptyStyle={{ display: 'flex' }}
            fillStyle={{ display: '-webkit-inline-box' }}
            fillIcon={<FaStar size={50} />}
            emptyIcon={<FaRegStar size={50} />}
          />
        </div>
        {starRatingError && <span className="text-red-600">{starRatingError}</span>}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label htmlFor="comentario">A ASSBAN gostaria de receber seu comentário:</label>
            <textarea
              id="comentario"
              className="border w-full p-2 min-h-[150px]"
              placeholder="Comentário"
              {...register('comentario', {
                maxLength: {
                  value: 1000,
                  message: 'Limite de 1000 caracteres excedido.',
                },
              })}
            />
            <span className="text-right block italic">{form_message?.trim().length || 0}/1000</span>
            {errors.comentario && <span className="text-red-600">{errors.comentario.message}</span>}
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="mt-5 flex items-center bg-[#503e9d40] text-[#503e9d] rounded-full py-3 px-5 mx-auto"
              disabled={sending}
            >
              ENVIAR
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
